<app-bar-chart
  [labels]="labels"
  [series]="series"
  [loading]="isLoading"
  [horizontal]="false"
  [options]="chartOptions"
></app-bar-chart>
